

const inkProgress = {
  bindings: {
    steps: '<',
    activeStep: '<',
    title: '<?',
    description: '<?'
  },
  template: require('./progress.template.html'),
  controller: function(_) {
    // this.stepWidth = (100 / this.steps.length) + '%';
    this.stepWidth =
    _.isUndefined(this.steps) ? true: (100 / this.steps.length) + '%';
    this.title = _.isUndefined(this.title) ? true : this.title;
    this.description =
    _.isUndefined(this.description) ? true : this.description;
  }
};

angular
  .module('inkfinder')
  .component('inkProgress', inkProgress);



// WEBPACK FOOTER //
// ./components/progress/progress.component.js